import * as ActionTypes from '../actions/StylingFirmsActionTypes';
import { IStylingFirm, IProduct } from '../Entities';
import { assign } from '../../../shared/Assign';

export const StylingFirmInitialState = {
    styling: {
        list: [],
        modal: {
            stylingFirm: {}
        },
        products: []
    }
};

export default function stylingFirmsReducer(
    state: any = StylingFirmInitialState.styling,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_STYLING_FIRMS_SUCCESS:
            return {
                ...state,
                list: action.result
            };

        case ActionTypes.SAVE_STYLING_FIRM_SUCCESS:
            return {
                ...state,
                list: [...state.list, action.result]
            };

        case ActionTypes.GET_STYLING_FIRM_SUCCESS:
            var newState = assign({}, state);
            newState.modal.stylingFirm = action.result;
            return newState;

        case ActionTypes.UPDATE_STYLING_FIRM_FORM_SUCCESS:
            return {
                ...state,
                list: [
                    ...state.list.filter((stylingFirm: IStylingFirm) => {
                        return stylingFirm.id !== action.result.id;
                    }),
                    action.result
                ]
            };

        case ActionTypes.GET_STYLING_FIRM_PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.result
            };

        case ActionTypes.ADD_STYLING_FIRM_PRODUCT_SUCCESS:
            return {
                ...state,
                list: [...state.list, action.result]
            };

        case ActionTypes.DELETE_STYLING_FIRM_SUCCESS:
            var newState = assign({}, state);
            newState.list = newState.list.filter((firm: IStylingFirm) => {
                return firm.id !== action.result.id;
            });
            return newState;

        default:
            return state;
    }
}
